var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:chat-new-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0202 4.66667C12.5111 4.66667 12.9091 5.06464 12.9091 5.55556C12.9091 6.04648 12.5111 6.44444 12.0202 6.44444H3.81818V18.3422L5.42091 17.1111H18.3636V11.798C18.3636 11.2959 18.7707 10.8889 19.2727 10.8889C19.7748 10.8889 20.1818 11.2959 20.1818 11.798V18C20.1818 18.2357 20.086 18.4618 19.9156 18.6285C19.7451 18.7952 19.5138 18.8889 19.2727 18.8889H6.05L3.60918 20.7639C2.95147 21.2691 2 20.8002 2 19.9708V5.55556C2 5.31981 2.09578 5.09372 2.26627 4.92702C2.43675 4.76032 2.66799 4.66667 2.90909 4.66667H12.0202ZM17.4545 4.66667V2.90909C17.4545 2.40701 17.8616 2 18.3636 2C18.8657 2 19.2727 2.40701 19.2727 2.90909V4.66667H21.1111C21.602 4.66667 22 5.06464 22 5.55556C22 6.04648 21.602 6.44444 21.1111 6.44444H19.2727V8.20202C19.2727 8.7041 18.8657 9.11111 18.3636 9.11111C17.8616 9.11111 17.4545 8.7041 17.4545 8.20202V6.44444H15.6162C15.1252 6.44444 14.7273 6.04648 14.7273 5.55556C14.7273 5.06464 15.1252 4.66667 15.6162 4.66667H17.4545Z",
    fill: "#7D7D7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/newChat.71176ddd371e78cef1914da9be439a88.svg";
export { ForwardRef as ReactComponent };